import {api} from 'macarons'
import axios from 'axios'
import Fingerprint2 from '@fingerprintjs/fingerprintjs'

function switchCrisp (contract) {
  if (document.getElementsByClassName('crisp-client').length) {
    [].forEach.call(document.getElementsByClassName('crisp-client'), el => {
      el.style.display = contract.crisp ? 'initial' : 'none'
    })
  } else {
    setTimeout(() => switchCrisp(contract), 100)
  }
}

function idleCallback (callback) {
  return window.requestIdleCallback ? requestIdleCallback(callback) : setTimeout(callback, 500)
}

export default {
  state () {
    return {
      boardAccess: null,
      contract: null,
      fingerprint: null,
      globalFilters: [],
      feedbacks: {},
      department: null,
      rome: null,
      secondary: false
    }
  },
  mutations: {
    setSecondary (state, secondary) {
      state.secondary = secondary
    },
    setDepartment (state, department) {
      state.department = department
    },
    setRome (state, rome) {
      state.rome = rome
    },
    setBoardAccess (state, boardAccess) {
      state.boardAccess = boardAccess
    },
    setFeedback (state, feedback) {
      state.feedbacks[feedback.key] = feedback.feedback
    },
    setGlobalFilters (state, filters) {
      state.globalFilters.splice(0, state.globalFilters.length, ...filters)
    },
    setContract (state, contract) {
      state.contract = contract
      switchCrisp(contract)
    },
    setUser (state, user) {
      state.contract = user.contract
      if (user.contract) {
        switchCrisp(user.contract)
      }
    },
    setFingerprint (state, fingerprint) {
      state.fingerprint = fingerprint
    }
  },
  actions: {
    async getBoardAccesses ({state, commit}) {
      if (!state.boardAccess) {
        commit('setBoardAccess', await api.get('/board/access').then(({data}) => {
          const boardAccess = {}
          data.forEach(entry => {
            if (typeof boardAccess[entry.dep] === 'undefined') {
              boardAccess[entry.dep] = {}
            }
            boardAccess[entry.dep][entry.fap] = entry.treat_group
          })
          return boardAccess
        }))
      }
      return state.boardAccess
    },
    async getBoardAccess ({state, dispatch, rootState}, board) {
      if (window[window.macarons].boardAccess) {
        return true
      }
      if (!window[window.macarons].globalFilters) {
        return true
      }
      if (rootState.token) {
        return true
      }
      if (!state.globalFilters.length === 6) {
        return false
      }
      const accesses = await dispatch('getBoardAccesses')
      if (typeof accesses[state.department] === 'undefined') {
        return false
      }
      if (typeof accesses[state.department][state.rome] === 'undefined') {
        return false
      }
      const group = accesses[state.department][state.rome]
      if (typeof window[window.macarons].allowedBoards === 'undefined') {
        return true
      }
      if (typeof window[window.macarons].allowedBoards[group] === 'undefined') {
        return true
      }
      board = parseInt(board)
      return window[window.macarons].allowedBoards[group].findIndex(id => id === board) !== -1
    },
    getFingerprint ({state, commit}) {
      if (state.fingerprint) {
        return Promise.resolve(state.fingerprint)
      }
      return new Promise((resolve, reject) => {
        idleCallback(() => {
          Fingerprint2.load().then(fp => {
            fp.get().then(result => {
              commit('setFingerprint', result.visitorId)
              resolve(result.visitorId)
            })
          })
        })
      })
    },
    async getUserIdentity ({dispatch, rootState}) {
      return {
        uid: rootState.user.email === 'dummy@lulhum.org' ? null : rootState.user.id,
        token: rootState.token,
        fingerprint: await dispatch('getFingerprint')
      }
    },
    async track ({dispatch}, payload) {
      const api = axios.create({
        baseURL: window[window.macarons].backGRC,
        headers: {
          'X-Auth-Token': ''
        }
      })
      return api.post('/track', {
        action: payload.action || null,
        data: payload.data ? JSON.stringify(payload.data) : null,
        url: payload.url || window.location.href,
        identity: await dispatch('getUserIdentity')
      })
    },
    load ({dispatch}) {
      return dispatch('loadTheme')
    },
    loadTheme () {
      return api.get('theme').then(({data}) => {
        const el = document.getElementById('theme-stylesheet')
        el.textContent = data
        el.parentNode.appendChild(el)
      }).catch(() => {
        const el = document.getElementById('theme-stylesheet')
        el.textContent = ''
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js